import { createSelector } from 'reselect';
import i18next from 'i18next';

import { OrderingSelectors } from 'polygon-ordering';
import { RootState } from 'store';
import { DELIVERY_SALE_TYPES } from '../libs/polygon-ordering/src/constants';

const { getSaleType, getSurcharges, getDeliveryFee } = OrderingSelectors;

const getFlattenDeliverySurcharges = (state: RootState) => state.config.flattenDeliverySurcharges;

export default createSelector(
  [getSurcharges, getFlattenDeliverySurcharges, getSaleType, getDeliveryFee],
  (surcharges = [], flattenDeliverySurcharges = true, saleType, deliveryFeeData) => {
    let deliverySurcharge: { description: undefined | string; amount: number } = {
      description: undefined,
      amount: 0,
    };

    const result = [];
    const isDeliveryCampaign =
      DELIVERY_SALE_TYPES.includes(saleType) && deliveryFeeData && deliveryFeeData.deliveryFee > 0;

    if (isDeliveryCampaign) {
      const newAmount = deliveryFeeData?.discountedDeliveryFee ?? deliveryFeeData.deliveryFee;

      deliverySurcharge = {
        ...deliverySurcharge,
        amount: newAmount,
      };
    }

    surcharges.forEach(surcharge => {
      if (
        flattenDeliverySurcharges &&
        (surcharge.description || i18next.t('surchargeNameFallback'))
          .toLowerCase()
          .startsWith('delivery')
      ) {
        if (isDeliveryCampaign) {
          // We do this cause when we use delivery campaigns we want to show the free delivery fee line
          deliverySurcharge = {
            ...deliverySurcharge,
            description: surcharge.description,
          };
        } else {
          deliverySurcharge = {
            ...deliverySurcharge,
            amount: deliverySurcharge.amount + surcharge.amount,
          };
        }
      } else {
        result.push(surcharge);
      }
    });

    if (flattenDeliverySurcharges) {
      const shouldPushDeliverySurcharge = isDeliveryCampaign ? true : deliverySurcharge.amount > 0;

      if (shouldPushDeliverySurcharge) {
        result.push(deliverySurcharge);
      }
    }

    return result;
  },
);
